const NAMESPACE = "attachmentMetadataComponent";

const KEYS = {
    fileNameLabel: "fileNameLabel",
    uploadedByLabel: "uploadedByLabel",
    uploadTimestampLabel: "uploadTimestampLabel",
    statusLastUpdatedByLabel: "statusLastUpdatedByLabel",
    statusLastUpdatedTimeLabel: "statusLastUpdatedTimeLabel",
    noteInputLabel: "noteInputLabel",
    approveBtnLabel: "approveBtnLabel",
    rejectBtnLabel: "rejectBtnLabel",
    saveBtnLabel: "saveBtnLabel",
    unmarkBtnLabel: "unmarkBtnLabel",
    updateSuccessAlertText: "updateSuccessAlertText",
    currentStatusLabel: "currentStatusLabel"
};
const MESSAGES = {
    [KEYS.fileNameLabel]: { value: "File Name:", comment: "Label for the file name of the attachment" },
    [KEYS.uploadedByLabel]: {
        value: "Uploaded By:",
        comment: "Label for the info about the user who uploaded the attachment"
    },
    [KEYS.uploadTimestampLabel]: {
        value: "Upload Timestamp:",
        comment: "Label for the timestamp at which the attachment was uploaded"
    },
    [KEYS.statusLastUpdatedByLabel]: {
        value: "Status Last Updated By:",
        comment: "Label indicating the user who last updated the attachment's approval status"
    },
    [KEYS.statusLastUpdatedTimeLabel]: {
        value: "Status Last Updated Timestamp",
        comment: "Label for the last time at which the approval status was updated"
    },
    [KEYS.noteInputLabel]: {
        value: "Notes to Applicant",
        comment:
            "Label for the text area input where the admin can enter additional information for the applicant related to the attachment's approval status"
    },
    [KEYS.approveBtnLabel]: { value: "Approve", comment: "Label for the button that allows approving the attachment" },
    [KEYS.rejectBtnLabel]: { value: "Reject", comment: "Label for the button that allows rejecting the attachment" },
    [KEYS.saveBtnLabel]: {
        value: "Save Note",
        comment: "Label for the button that updates the attachment note without modifying its approval status"
    },
    [KEYS.unmarkBtnLabel]: {
        value: "Unmark Status",
        comment: "Label for the button that clears the current approval status"
    },
    [KEYS.updateSuccessAlertText]: {
        value: "Attachment note and approval status successfully saved.",
        comment: "Alert message to tell the user when the approval status and note have been successfully updated"
    },
    [KEYS.currentStatusLabel]: {
        value: "Current Status:",
        comment: "Label for the attachment's current approval status"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
